<template>
    <div id="expertsLoadingBox" v-if="isLoading">
        <img class="d-none d-md-block mb-4" style="opacity:0.6;" src="/wp-content/themes/understrap-child/fidelio-templates/images/expertsPlaceholder.svg" alt="">
        <img class="d-md-none mb-4" style="opacity:0.6;" src="/wp-content/themes/understrap-child/fidelio-templates/images/expertPlacholderMobile.svg" alt="">
    </div>
    <div>
        <div v-if="experts && experts.length" class="mb-4 px-5 py-1 rounded-corners-10">
            <div class="text-primary my-3 px-4 px-md-0">
                <h5 class="font-weight-bolder" style="font-size: x-large;">{{ $t('CategoryPage.experts') }}</h5>
            </div>
            <div class="splide expertSplide newFeatureSlider" aria-label="Slider for Experts">
                <div class="sands-article-vueslidercontainer splide__track">
                    <div class="splide__list">
                        <div class="sands-author-detail text-center feature-detail-article-authors splide__slide d-flex" v-for="(expert, i) in experts" :key="i">
                            <a v-if="expert.slug" :href="constructCourseURL(expert)">
                                <div v-if="expert.avatarSquareSmall && expert.avatarSquareSmall.xx" class="mb-2 expert-img-size">
                                    <img class="h-100 img-fluid rounded fixed-aspect-ratio-expert expert-img-cover" :src="expert.avatarSquareSmall.xx" loading="lazy" />
                                </div>
                                <div class="text-dark text-break">
                                    <span v-if="expert.forename" class="mr-1"> {{ expert.forename }} </span>
                                    <span v-if="expert.surname" class="font-weight-bolder"> {{ expert.surname }} </span>
                                    <span v-if="expert.surname" class="font-weight-bolder"> {{ expert.aCourse }} </span>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Splide from '@splidejs/splide';
import helperFunction from "../../services/helperfunctions.js";
import { watch } from 'vue';
import useElementVisible  from "../../services/elementVisibilityService.js" ;
import axios_queries from '../../services/axios_queries.js';
import CONCORD_QUERIES from "../../services/concord_queries.js"


export default {
    name: "categoryExperts",
    props: {
        settingsPerm: Object,
    },
    data() {
        return {
            isLoading: true,
            experts: false,
            loadMorePossible: true,
            isDevMioActive: false,
            currentPage: 1,
            metaCount: 0,
            splide: null,
            box1Ref: null,
            firstTimeInViewport: true,
        }
    },

    created() {
        setTimeout(() => {
        this.box1Ref = document.getElementById('expertsLoadingBox');

        if (this.box1Ref) {
            const isVisible  = useElementVisible(this.box1Ref);
            if (isVisible && isVisible.value && isVisible.value == true) {
              this.firstTimeInViewport = false;
              this.loadInitialData();
            }
            watch(isVisible, () => {
            if (this.firstTimeInViewport && isVisible) {
                this.firstTimeInViewport = false;
                this.loadInitialData();
            }
            // Do something when isVisible changes
            });
        }
        }, 500);
        if (this.settingsPerm && this.settingsPerm.isDevMioActive) {
            this.isDevMioActive = this.settingsPerm.isDevMioActive;
        }
    },

    methods: {
        loadInitialData() {
            let authorsLoadingParams = {
                page: 1,
                pagesize: 12,
                querystring: this.settingsPerm.cat,
                transientKey: this.settingsPerm.cat+'-cat-depending-authors-vue-data',
                query:  "cat-depending-authors-vue",
                url: this.settingsPerm.ajaxUrl+'/wp-content/uploads/catpages/'+this.settingsPerm.cat+'-cat-depending-authors-vue-data.json'
            };
            axios_queries.loadPublicData(authorsLoadingParams).then((concordData) => {
                if (concordData && concordData != null && concordData != undefined && concordData != '') {
                     if (concordData.advancedSearch && concordData.advancedSearch.authors && concordData.advancedSearch.authors.Authors && concordData.advancedSearch.authors.Authors.length) {
                        this.displayAuthorsData(concordData.advancedSearch.authors.Authors);
                    }
                } 
            })

        },

        displayAuthorsData(experts){
            this.experts = experts
            this.isLoading = false;
            this.mount_splide();
        },

        async loadMoreData() {
            this.currentPage = this.currentPage + 1;
            let variablesForQuery = {
                page: this.currentPage,
                pagesize: 12,
                querystring: this.settingsPerm.cat,
            };
            const graphqlQuery = CONCORD_QUERIES.CAT_SPECIFIC_EXPERTS;
            try {
                let concordData = await axios_queries.getMoreData(graphqlQuery,variablesForQuery);
               if (concordData.advancedSearch && concordData.advancedSearch.authors && concordData.advancedSearch.authors.Authors && concordData.advancedSearch.authors.Authors.length)  {
                    const newexperts = concordData.advancedSearch.authors.Authors;
                    this.experts = [...this.experts, ...newexperts];
                    this.mount_splide();
                }
            } catch (error) {
                console.log(error);
            }
        },

        addMovedEventListener() {
            this.splide.on('moved', (newIndex) => {
                const lastCardIndex = newIndex + this.splide.options.perPage;
                // console.log('lastcardindex', lastCardIndex);
                // console.log('lenght', this.experts.length);

                if (lastCardIndex === this.experts.length - 2 && this.experts.length > this.metaCount) {
                    this.loadMoreData();
                }
            });
        },

        constructCourseURL(concordObject) {
            if (this.isDevMioActive && concordObject && concordObject.slug) {
                return "/experts/" + concordObject.slug;
            }else{
                return helperFunction.sandsConstructRealUrl(concordObject);
            }
            
        },

        mount_splide: function () {
            let thiz = this;
            setTimeout(function () {
                if (!thiz.splide) {
                    thiz.splide = new Splide('.expertSplide', {
                        classes: {
                            prev: 'splide__arrow--prev xx',
                            next: 'splide__arrow--next xxx',
                            arrow: 'splide__arrow xxxx',
                        },
                        perPage: 5,
                        perMove: 1,
                        rewindByDrag: true,
                        gap: '1rem',
                        breakpoints: {
                            1024: {
                                perPage: 5,
                                padding: {
                                    right: '0rem',
                                    left: '0rem',
                                }
                            },
                            991: {
                                perPage: 3,
                                padding: {
                                    right: '0rem',
                                    left: '0rem',
                                }
                            },
                            767: {
                                perPage: 2,
                                padding: {
                                    right: '0rem',
                                    left: '0rem',
                                }
                            },
                        },
                        rewind: false,
                        pagination: false,
                        padding: {
                            right: '0rem',
                            left: '0rem',
                        }
                    });
                    thiz.splide.mount();
                    thiz.addMovedEventListener(); // Add event listener
                } else {
                    thiz.splide.refresh(); // Refresh the existing Splide instance
                }
            }, 100);
        },

    },

};
</script>
<style>
.expert-img-size{
    height: calc(100% - 30px);
}
.fixed-aspect-ratio-expert {
  aspect-ratio: 1 / 1; /* 1:1 aspect ratio */
}
.expert-img-cover{
    object-fit: cover;
}
</style>